import { useMemo } from 'react';
import { CountryEnum, type CountryEnumType } from '@sr/types';
import { LEARNING_MARKET_FLAGS } from '@sr/utils';
import { useFlag } from './useFlag';

export const useLearningMarketFlags = (): Record<CountryEnumType, boolean> => {
  const sweden = useFlag(LEARNING_MARKET_FLAGS.SE);
  const norway = useFlag(LEARNING_MARKET_FLAGS.NO);
  const denmark = useFlag(LEARNING_MARKET_FLAGS.DK);
  const finland = useFlag(LEARNING_MARKET_FLAGS.FI);
  const poland = useFlag(LEARNING_MARKET_FLAGS.PL);

  return useMemo(
    () => ({
      [CountryEnum.SE]: sweden,
      [CountryEnum.NO]: norway,
      [CountryEnum.DK]: denmark,
      [CountryEnum.FI]: finland,
      [CountryEnum.PL]: poland,
    }),
    [sweden, norway, denmark, finland, poland],
  );
};
